/**
 * Single source of truth for the per-cell error index key. The table store's
 * `errorsByCell` / `pifErrorsByCell` (keyed by node number) and
 * `errorsByCellId` / `pifErrorsByCellId` (keyed by node id) computeds build
 * their Map keys with this, and `cell.tsx` builds both lookup keys with it —
 * keeping every side in lockstep so a format change can't silently break error
 * highlighting.
 *
 * The first argument is either a numeric `nodeNumber` or a `nodeId` UUID (which
 * itself contains `-`). The `-` between the two arguments is still an
 * unambiguous separator because `colId` is a fixed `NodeColumns` value with no
 * dashes and is always the suffix — the key is only ever compared for equality,
 * never parsed back apart.
 */
export function cellErrorKey(
  nodeNumberOrId: number | string | null | undefined,
  colId: string
): string {
  return `${nodeNumberOrId}-${colId}`;
}
